import React from 'react';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';
import history from '../../history';

import ButtonIcon from 'cyder/button/ButtonIcon';
import CertificationRenewalAnalyticsToolbar from 'pages/analytics/components/certification-renewal/CertificationRenewalAnalyticsToolbar';
import CertificationRetentionRate from 'pages/analytics/components/certification-renewal/CertificationRetentionRate';
import CertificationRetentionChart from 'pages/analytics/components/certification-renewal/CertificationRetentionChart';
import CertificationRenewalList from 'pages/analytics/components/certification-renewal/CertificationRenewalList';
import DistributionOfTerminationList from 'pages/analytics/components/certification-renewal/DistributionOfTerminationList';
import { Row, Col, Container } from 'reactstrap';

var buttonStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
};

const AnalyticsButton = ({ btnProps, colStyle, onClick, label, check }) => {
    let buttonColor = null;
    let fontColor = null;
    if (check) {
        buttonColor = 'grey';
        fontColor = 'white';
    }
    return (
        <Row style={{ marginBottom: '5px' }}>
            <Col style={colStyle}>
                <ButtonIcon label={label} onClick={onClick} {...btnProps} buttonColor={buttonColor} fontColor={fontColor} />
            </Col>
        </Row>
    );
};

class CertificatesRenewalAnalytics extends React.Component {
    constructor(props) {
        super(props);
        // this.handleInputChange = this.handleInputChange.bind(this);
    }

    render() {
        return (
            <Container>
                <Row style={{ marginBottom: '20px' }}>
                    <Col xs={12}>
                        <Row className="float-right">
                            <AnalyticsButton
                                colStyle={buttonStyle}
                                onClick={e => {
                                    history.push('/staff/analytics/certification');
                                }}
                                label="Certification Analytics"
                            />
                            <AnalyticsButton
                                colStyle={buttonStyle}
                                onClick={e => {
                                    history.push('/staff/analytics/certification/issuedanalytics');
                                }}
                                label="Issued Analytics"
                            />
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginBottom: '20px' }}>
                    <Col xs={12}>
                        <CertificationRenewalAnalyticsToolbar />
                    </Col>
                </Row>
                <Row style={{ marginBottom: '20px' }}>
                    <Col xs={7}>
                        <CertificationRenewalList />
                        <DistributionOfTerminationList />
                    </Col>
                    <Col xs={5}>
                        <CertificationRetentionRate />
                        <CertificationRetentionChart />
                    </Col>
                </Row>
            </Container>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(CertificatesRenewalAnalytics));
